import { render, staticRenderFns } from "./GroupCategoryCreate.vue?vue&type=template&id=2c7b0082"
import script from "./GroupCategoryCreate.vue?vue&type=script&lang=js"
export * from "./GroupCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports